/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询我的评论列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetProductCommentsParams {
  constructor(public pageNum: number, public pageSize: number) {}
}

export default async function (
  params: GetProductCommentsParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.ProductCommentDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/comments`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
